import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Contigo MSJ Portal';
  constructor(private translate: TranslateService) {
      translate.addLangs(['en', 'es']);
      if (localStorage.getItem('locale')) {
        const browserLang = localStorage.getItem('locale');
        translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
      } else { 
        localStorage.setItem('locale', 'en');
        translate.setDefaultLang('en');
      }
  }

  ngOnInit(): void {
  }
}
